// extracted by mini-css-extract-plugin
export default {"divider":"c26u4S4tf0D_siBBZp0g"};